var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reviews && _vm.dataLoaded
    ? _c("span", [
        _c("span", { staticClass: "rating" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "rate",
              staticStyle: { width: "0%" },
              style: "width:" + _vm.reviews.rating.replace(",", ".") * 20 + "%",
            },
            [
              _c("i", { staticClass: "fa fa-star" }),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-star" }),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-star" }),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-star" }),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-star" }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("strong", { staticClass: "t rate-count" }, [
          _vm._v(_vm._s(_vm.reviews.rating) + " "),
          _c("span", [
            _vm._v(_vm._s(_vm.$translate("reviewWidget::Template.outof"))),
          ]),
          _vm._v(" " + _vm._s(_vm.reviews.userScore)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "t txt" }, [
          _vm._v(_vm._s(_vm.$translate("reviewWidget::Template.summary2"))),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "blank" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }